import { DataBean } from "../../DataBean";


export class ImpAdquisition extends DataBean {

    public async importAdquisitionItem(idEmployee: any,idAdquisitionPlan:any, media: any, mediaContext: any): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.shared.Report_importAdquisitionItem_Number_Number_String_String", [idEmployee,idAdquisitionPlan, media, mediaContext]);
    }
   public async importAdquisitionItemBudgetID(idEmployee: any,idAdquisitionPlan:any, media: any, mediaContext: any): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.shared.Report_importAdquisitionItemBudgetID_Number_Number_String_String", [idEmployee,idAdquisitionPlan, media, mediaContext]);
    }
}